ixModuleRouting("impactx.manufacturer", {
    "/manufacturer/:id/:useSetFilter?": {
        template: "<ixa-manufacturer></ixa-manufacturer>",
        templateUrl: "modules/manufacturer/templates/manufacturer.html",
        controller: "ManufacturerDialogCtrl",
        controllerAs: "manufacturerDialogCtrl",
        process: "Search",
        workspace: "shop",
    },
});
